module.exports = __webpack_public_path__ + "img/bg_img04.0a1b990d.png";